<script setup lang="ts">
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import { useSlots } from "vue";

const slots = useSlots();
</script>

<template>
  <div class="le-error-results">
    <LeHeading tag="h2" size="m" class="le-error-results__header">
      <slot name="header" />
    </LeHeading>

    <p
      :class="{ 'le-error-results__paragraph--no-button': !slots.paragraph2 && !slots.button }"
      class="le-error-results__paragraph"
    >
      <slot name="paragraph1" />
    </p>

    <LeHeading v-if="slots.section" tag="h4" class="le-error-results__section-header">
      <slot name="section" />
    </LeHeading>

    <p
      v-if="slots.paragraph2"
      :class="{ 'le-error-results__paragraph--no-button': !slots.button }"
      class="le-error-results__paragraph"
    >
      <slot name="paragraph2" />
    </p>

    <template v-if="slots.button">
      <slot name="button" />
    </template>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-error-results {
  max-width: calc(100vw - 30px);
  padding: 12px 20px 20px;
  border-radius: 4px;
  background-color: white;

  &__header {
    margin-bottom: 12px;
    color: @colors[@primary][900];
  }

  &__paragraph {
    margin-bottom: 18px;
    .body-text("s");
    color: @colors[@primary][900];

    &--no-button {
      margin-bottom: 0;
    }
  }

  &__section-header {
    .body-text("s", "semi-bold");
    color: @colors[@primary][900];
  }
}
</style>
